import { render, staticRenderFns } from "./HarvestFarmStats.vue?vue&type=template&id=b23aa656&lang=html&"
import script from "./HarvestFarmStats.vue?vue&type=script&lang=js&"
export * from "./HarvestFarmStats.vue?vue&type=script&lang=js&"
import style0 from "./HarvestFarmStats.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports